module.exports = __webpack_public_path__ + "static/media/kler-apps.7779e56c.png";